export const submitFormOnEnter = (event) => {
    if (event?.isComposing) {
        return
    }

    const target = event?.target
    if (target?.tagName?.toLowerCase() === 'textarea') {
        return
    }

    const form = event?.currentTarget
    if (form?.tagName?.toLowerCase() !== 'form') {
        return
    }

    event.preventDefault()

    if (typeof form.requestSubmit === 'function') {
        try {
            form.requestSubmit()
            return
        } catch {
            // Fall back to dispatching submit for environments without requestSubmit support.
        }
    }

    const eventConstructor = form.ownerDocument?.defaultView?.Event

    if (typeof eventConstructor === 'function') {
        form.dispatchEvent(
            new eventConstructor('submit', { bubbles: true, cancelable: true })
        )
    }
}
